import { createSelector } from 'reselect'

const selectCake = state => state.cake

// export const selectFeaturedCake = createSelector(
//     [selectCake],
//     cake => cake.featured
// )

export const selectLineUpCake = createSelector(
    [selectCake],
    cake => cake.lineUp
)

export const selectInstagram = createSelector(
    [selectCake],
    cake => cake.instagram
)

// export const selectSingleFeaturedCake = id => createSelector(
//     [selectCake],
//     cake => cake.featured.find(item => item.id === id)
// )

export const selectSingleLineUpCake = id => createSelector(
    [selectCake],
    cake => cake.lineUp.find(item => item.id === id)
)